import React from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import { ArrowRightIcon } from 'assets/icons';
import { NotifierTypes } from 'constants/notifierConstants';
import MerchantOrTeamBlockedInfoPanel from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfoPanel';
import { EditAmountMainSection } from './EditAmountMainSection';
import { InvoiceByIdV2 } from '../invoices.model';
import { showNotification } from 'utils/Notifier';
import { getAmountWithCurrency, roundToTwoDecimals } from 'utils/amountUtils';

interface RecordPaymentEditAmountProps {
  invoiceData: InvoiceByIdV2;
  onBack: () => void;
  onSave: (amount: number) => void;
  initialAmount?: number;
}

export const RecordPaymentEditAmount: React.FC<RecordPaymentEditAmountProps> = ({
  invoiceData,
  onBack,
  onSave,
  initialAmount
}) => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);
  const dispatch = useAppDispatch();

  const handleSave = (amount: number) => {
    // Validate amount
    if (amount <= 0) {
      showNotification(dispatch, NotifierTypes.ERROR, 'Please enter a valid amount greater than 0');
      return;
    }

    const totalAmount = Number(invoiceData?.pendingAmount || invoiceData?.totalAmount);
    if (amount > totalAmount) {
      showNotification(
        dispatch,
        NotifierTypes.ERROR,
        `Amount cannot exceed the remaining amount of ${getAmountWithCurrency(roundToTwoDecimals(totalAmount))}`
      );
      return;
    }

    onSave(amount);
  };

  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfoPanel onBack={onBack} />;
  }

  return (
    <div className="flex h-full flex-col">
      <div
        className="flex cursor-pointer items-center gap-4 border-b
       border-borderGray p-4 text-17px font-semibold text-primaryText"
        onClick={onBack}>
        <ArrowRightIcon
          className="path-fill-current path h-5 w-5
              shrink-0 rotate-180 cursor-pointer text-heading "
        />
        Payment amount
      </div>
      <EditAmountMainSection
        invoiceData={invoiceData}
        onSave={handleSave}
        initialAmount={initialAmount}
        onCancel={onBack}
      />
    </div>
  );
};
